import React from "react";
import { Fragment } from "react";
import Navbar from "./shared/Navbar/Navbar";
import LandingPage from "./shared/LandingPage/LandingPage";
import { Route, Routes } from "react-router-dom";
import Quiz from "./components/Quiz";
import Chatbot from "./components/Chatbot";
import PoliticaPrivacidade from "./components/PoliticaPrivacidade";
import Automacao from "./components/Automacao";

function App() {
  return (
    <Fragment>
      <Navbar />
      {/* <LandingPage /> */}
      <Routes>
        <Route exact path="/" element={<LandingPage />} /><Route />
        <Route exact path="/quiz" element={<Quiz />} /><Route />
        <Route exact path="/politica" element={<PoliticaPrivacidade />} /><Route />
        <Route exact path="/uso" element={<PoliticaPrivacidade />} /><Route />
        <Route exact path="/auto" element={<Automacao />} /><Route />
      </Routes>
      {/* <Chatbot /> */}
    </Fragment>
  );
}

export default App;
